__turbopack_context__.v({
  "address": "property-view-module__CnSIZa__address",
  "description": "property-view-module__CnSIZa__description",
  "gallery": "property-view-module__CnSIZa__gallery",
  "head": "property-view-module__CnSIZa__head",
  "headline": "property-view-module__CnSIZa__headline",
  "homesTitle": "property-view-module__CnSIZa__homesTitle",
  "photo": "property-view-module__CnSIZa__photo",
  "title": "property-view-module__CnSIZa__title",
});
